import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import * as Utils from "./Utils";
var styles = function styles(theme) {
  return {
    company: {
      color: theme.palette.primary.main
    },
    caption: {
      color: theme.palette.text.secondary
    }
  };
};
function VersionInfo(_ref) {
  var classes = _ref.classes,
    appName = _ref.appName;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    versionInfo = _useState2[0],
    setVersionInfo = _useState2[1];
  React.useEffect(function () {
    Utils.fetchData("application/auth/versionInfo", null, false, false).then(function (response) {
      return response.text();
    }).then(function (data) {
      setVersionInfo(data);
    }).catch(function (error) {
      // Ignore
    });
  }, []);
  if (!versionInfo) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row"
  }, /*#__PURE__*/React.createElement(Box, {
    p: 0.25
  }, /*#__PURE__*/React.createElement(Typography, {
    noWrap: true,
    variant: "body2",
    className: classes.company
  }, appName)), /*#__PURE__*/React.createElement(Box, {
    p: 0.25
  }, /*#__PURE__*/React.createElement(Typography, {
    noWrap: true,
    variant: "caption",
    className: classes.caption
  }, versionInfo)));
}
export default withStyles(styles)(VersionInfo);